import { createContext, useContext, useState } from 'react';

import { GHL_FORM_URLS } from '../../constants/config';

const GHLFormModalContext = createContext();

export const GHLFormModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [formConfig, setFormConfig] = useState({
    formURL: GHL_FORM_URLS.bookConsultation,
    prefillData: {},
  });

  const openModal = ({ formURL, prefillData = {} } = {}) => {
    setFormConfig({
      formURL: formURL || GHL_FORM_URLS.bookConsultation,
      prefillData,
    });
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <GHLFormModalContext.Provider value={{ isOpen, formConfig, openModal, closeModal }}>
      {children}
    </GHLFormModalContext.Provider>
  );
};

export const useGHLFormModal = () => {
  const context = useContext(GHLFormModalContext);
  if (!context) {
    throw new Error('useGHLFormModal must be used within GHLFormModalProvider');
  }
  return context;
};
